import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Download, Apple } from "lucide-react";
import { api, euro, errMsg, scarica } from "@/lib/api";
import { Page, Spinner } from "@/components/Layout";
import { VetrineReview, OperatoriAdmin, PianiAdmin, PagamentiAdmin, GiftCardAdmin, AuditAdmin } from "@/pages/admin/Tabs";
import Fatturazione from "@/pages/admin/Fatturazione";

const TABS = [["riepilogo", "Riepilogo"], ["vetrine", "Approvazioni"], ["operatori", "Operatori"], ["piani", "Piani"], ["pagamenti", "Quote spazio"], ["fatture", "Fatture"], ["giftcard", "Gift card"], ["audit", "Audit"]];

const Riepilogo = () => {
  const [d, setD] = useState(null);
  useEffect(() => {
    api.get("/admin/riepilogo").then((r) => setD(r.data));
  }, []);
  if (!d) return <Spinner />;
  const stats = [["Incassi quote spazio", euro(d.quote_cent), "stat-quote"], ["Commissioni gift card", euro(d.commissioni_cent), "stat-commissioni"],
    ["Venduto gift card", euro(d.venduto_cent), "stat-venduto"], ["Rimborsi", euro(d.rimborsi_cent), "stat-rimborsi"],
    ["Operatori attivi", `${d.operatori_attivi_n} / ${d.operatori_n}`, "stat-operatori"], ["Vetrine in revisione", d.vetrine_in_revisione_n, "stat-revisione"],
    ["Gift card attive", d.giftcard_attive_n, "stat-gc-attive"], ["Ordini pagati", d.ordini_n, "stat-ordini"]];
  const applePay = async () => {
    try {
      const { data } = await api.post("/admin/applepay-dominio");
      toast.success(`Dominio ${data.dominio} registrato (Apple Pay: ${data.apple_pay || "in verifica"})`);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map(([l, v, id]) => (
          <div key={id} className="card"><p className="caption">{l}</p><p className="font-display text-3xl mt-2" data-testid={id}>{v}</p></div>
        ))}
      </div>
      <div className="card">
        <h3 className="font-display text-2xl">Export CSV</h3>
        <div className="flex flex-wrap gap-3 mt-4">
          {["operatori", "giftcard", "ordini", "pagamenti", "fatture", "movimenti"].map((t) => (
            <button key={t} className="btn-secondary btn-sm" data-testid={`export-${t}-btn`} onClick={() => scarica(`/admin/export/${t}`, `${t}.csv`)}><Download size={14} />{t}</button>
          ))}
        </div>
      </div>
      <div className="card">
        <h3 className="font-display text-2xl">Apple Pay</h3>
        <p className="text-sm text-[#786E65] mt-1">Registra il dominio del sito su Stripe per abilitare Apple Pay nel Payment Element.</p>
        <button className="btn-outline btn-sm mt-4" onClick={applePay} data-testid="applepay-domain-btn"><Apple size={14} />Registra dominio</button>
      </div>
    </div>
  );
};

export default function AdminDashboard() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "riepilogo";
  return (
    <Page>
      <p className="caption">Amministrazione</p>
      <h1 className="font-display text-4xl sm:text-5xl mt-2">Pannello admin</h1>
      <div className="flex gap-1 overflow-x-auto border-b border-[#E3D9F0] mt-8">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setSp({ tab: k })} data-testid={`admin-tab-${k}`}
            className={`px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${tab === k ? "border-[#7E5BAF] text-[#7E5BAF]" : "border-transparent text-[#786E65] hover:text-[#261E1B]"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-8">
        {tab === "riepilogo" && <Riepilogo />}
        {tab === "vetrine" && <VetrineReview />}
        {tab === "operatori" && <OperatoriAdmin />}
        {tab === "piani" && <PianiAdmin />}
        {tab === "pagamenti" && <PagamentiAdmin />}
        {tab === "fatture" && <Fatturazione />}
        {tab === "giftcard" && <GiftCardAdmin />}
        {tab === "audit" && <AuditAdmin />}
      </div>
    </Page>
  );
}
